import React from 'react';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';
import { Button } from 'reactstrap';
import { useIntl } from 'react-intl';
import { userHasFeature } from '../../../helpers/Features';

const AdminTaxonomyEditHeader = ({ taxonomyId }) => {
  const intl = useIntl();
  const history = useHistory();

  return (
    <header className="page-header">
      <h3 className="page-title">
        {taxonomyId ? intl.formatMessage({ defaultMessage: 'Edit Tag Category' }) :
          intl.formatMessage({ defaultMessage: 'New Tag Category' })}
      </h3>
      <div className="header-actions users-actions">
        <div className="button-wrapper">
          {taxonomyId && (
            <Button
              color="primary"
              onClick={() => { history.push({ pathname: '/admin/settings/categories/add' }); }}
              disabled={!userHasFeature('custom-categories')}
            >
              <i className="fas fa-plus" />
              {intl.formatMessage({ defaultMessage: 'Tag Category' })}
            </Button>
          )}
        </div>
      </div>
    </header>
  );
};

AdminTaxonomyEditHeader.propTypes = {
  taxonomyId: PropTypes.string,
};

AdminTaxonomyEditHeader.defaultProps = {
  taxonomyId: null,
};

export default AdminTaxonomyEditHeader;
